import React from "react";
import DialogLoading from "./DialogLoading";

const LoadingContent = () => <DialogLoading onClose={() => {}} open />;

export default LoadingContent;
